/**
 * Base URL of the CodeBlue API.
 *
 * Set REACT_APP_API_URL in `.env` (or `.env.local`) to point the admin at a
 * different environment — see `.env.example`. Create React App inlines this at
 * build time, so the dev server must be restarted after changing it.
 *
 * The fallback is the local backend. Note the port: the Nest API listens on
 * 5001 (`PORT` in the backend `.env`), not 5000 — on macOS port 5000 is taken
 * by the AirPlay Receiver, which answers every request with a bare 403.
 */
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';
